import React from 'react';
import { MapContainer, TileLayer, Marker, Circle } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import ambulanceMarker from '@/assets/emt-ambulans-marker.svg';

const ambulanceIcon = new L.Icon({
  iconUrl: ambulanceMarker,
  iconSize: [60, 60],
  iconAnchor: [30, 30],
  popupAnchor: [0, -30],
  tooltipAnchor: [0, -30],
});

const VehicleMap = ({ latitude, longitude, radius = 80, zoom = 17 }) => {
  if (latitude == null || longitude == null) {
    return (
      <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
        Konum bilgisi bulunamadı.
      </div>
    );
  }

  const position = [latitude, longitude];

  return (
    <MapContainer
      center={position}
      zoom={zoom}
      style={{ height: '100%', width: '100%' }}
      scrollWheelZoom={false}
    >
      <TileLayer
        attribution="&copy; OpenStreetMap contributors"
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Circle
        center={position}
        radius={radius}
        pathOptions={{ color: '#2563eb', fillColor: '#3b82f6', fillOpacity: 0.15 }}
      />
      <Marker position={position} icon={ambulanceIcon} />
    </MapContainer>
  );
};

export default VehicleMap;

